import { AxiosError } from "axios";
import { trackerApi } from "../api/TrackerApi";
import { StaleTimeEnum, useQueryObject } from "../components/helpers/queryHelper";


const fetchCredentials = async () => {
    let data: boolean = await trackerApi.callServiceGet("/authentication/credentials").catch((error: AxiosError) => {
        return false;

    });
    return { value: data };

}

export const useQueryCheckCredentials = () => {

    let query = useQueryObject<{ value: boolean }>("credentials", fetchCredentials, "", StaleTimeEnum.LOW)

    return query;
}